/* eslint-disable @typescript-eslint/no-explicit-any */
// Get the first paragraph of text from the body (without any HTML or other
// formatting)
export function getSEODescription(body: any[]) {
  if (body === undefined) {
    return "";
  }
  const extractText = (block: any) =>
    block.children.map((c: any) => c.text).join(" ") as string;

  for (let i = 0; i < body.length; i++) {
    const block = body[i];

    // Discard images and other block types
    if (block._type !== "block") continue;

    // Extract text to get unformatted string
    const text = extractText(block);
    // Sometimes empty blocks of text are created at the beginning of the body,
    // discard them.
    if (!text.length) continue;

    // if we have a paragraph, we're done
    return text;
  }

  return "";
}
